import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ImageDialogComponent } from 'src/app/dialogs/components/image-dialog/image-dialog.component';
import { DialogIds } from 'src/app/dialogs/models/dialog-ids';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageViewComponent implements OnInit {

  @ViewChild('imageView', { static: true})
  imageView: ElementRef;

  @Input()
  fit: 'normal' | 'auto' = 'normal';

  @Input()
  fitSize: number;

  @Input()
  src: string;
  
  @Input()
  fullscreenSrc: string;

  @Input()
  alt: string;

  fullscreen$: Observable<Event>;
  fullscreenElement: HTMLElement;
  requestFullscreen: boolean;

  fullscreenEnabled = false;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  handleFullscreen(event: Event) {
    const options = {
      id: DialogIds.ImageDialog,
      backdropClass: 'bd-dialog-backdrop',
      panelClass: 'bd-dialog-panel',
      disableClose: false,
      data: {
        src: this.fullscreenSrc || this.src,
        alt: this.alt || ''
      }
    };
    
    this.dialog.open(ImageDialogComponent, options);

    event.stopPropagation();
  }
}
